var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApSmokeControlSystemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.646 -128.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.354 128.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.359,134.46H22.482c-.267,0-.482-.313-.482-.7V129c0-.388.215-.7.482-.7H52.359c.267,0,.482.313.482.7v4.758C52.841,134.147,52.626,134.46,52.359,134.46Zm-29.395-1.4H51.877V129.7H22.964Z",
    transform: "translate(-21.768 -128.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.615,298.143H116.151c-.25,0-.451-.312-.451-.7V291.9c0-.388.2-.7.451-.7h24.461c.25,0,.451.313.451.7v5.541C141.066,297.827,140.863,298.143,140.615,298.143Zm-24.012-1.4h23.559V292.6H116.6Z",
    transform: "translate(-112.731 -286.442)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.969 10.298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.2,494.531H119.6c-.179,0-.342-.167-.414-.421l-3.435-12.229a1.048,1.048,0,0,1,.036-.663.446.446,0,0,1,.378-.318h24.461a.448.448,0,0,1,.378.318,1.036,1.036,0,0,1,.036.663L137.61,494.11C137.539,494.365,137.377,494.531,137.2,494.531Zm-17.3-1.4h17l3.04-10.827H116.858Z",
    transform: "translate(-115.717 -480.9)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.877 3.101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M766.7,594.622a.7.7,0,0,1-.7-.7V587.9a.7.7,0,1,1,1.4,0v6.023A.7.7,0,0,1,766.7,594.622Z",
    transform: "translate(-754.895 -587.197)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M569.295,594.5a.7.7,0,0,1-.692-.608l-.821-6.022a.7.7,0,1,1,1.387-.19l.821,6.022a.7.7,0,0,1-.6.789A.566.566,0,0,1,569.295,594.5Z",
    transform: "translate(-567.775 -587.075)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.877,594.6c-.032,0-.064,0-.1-.006a.7.7,0,0,1-.6-.789l.821-6.022a.7.7,0,1,1,1.387.19l-.821,6.022A.7.7,0,0,1,936.877,594.6Z",
    transform: "translate(-925.415 -587.172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.071,594.521a.7.7,0,0,1-.678-.523l-1.574-6.022a.7.7,0,0,1,1.355-.357l1.574,6.023a.7.7,0,0,1-.5.856A.623.623,0,0,1,388.071,594.521Z",
    transform: "translate(-385.796 -587.096)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093,594.521a.75.75,0,0,1-.178-.023.7.7,0,0,1-.5-.856l1.574-6.023a.7.7,0,1,1,1.355.356L1093.675,594A.7.7,0,0,1,1093,594.521Z",
    transform: "translate(-1071.661 -587.096)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.389,387.5H254.8a.7.7,0,1,1,0-1.4h2.588a.7.7,0,1,1,0,1.4Z",
    transform: "translate(-254.1 -386.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.189,387.5H488.6a.7.7,0,1,1,0-1.4h2.588a.7.7,0,1,1,0,1.4Z",
    transform: "translate(-481.071 -386.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.989,387.5H722.4a.7.7,0,1,1,0-1.4h2.588a.7.7,0,1,1,0,1.4Z",
    transform: "translate(-708.043 -386.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.789,387.5H956.2a.7.7,0,1,1,0-1.4h2.588a.7.7,0,0,1,0,1.4Z",
    transform: "translate(-935.014 -386.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.589,387.5H1190a.7.7,0,1,1,0-1.4h2.588a.7.7,0,1,1,0,1.4Z",
    transform: "translate(-1161.986 -386.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.602 26.906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.1,1023.694c-.388,0-.7-.223-.7-.5a2.488,2.488,0,0,1,.523-1.564,1.86,1.86,0,0,0,0-2.268,2.6,2.6,0,0,1,0-3.129,1.73,1.73,0,0,0,.386-1.134c0-.277.313-.5.7-.5s.7.223.7.5a2.488,2.488,0,0,1-.523,1.564,1.86,1.86,0,0,0,0,2.268,2.6,2.6,0,0,1,0,3.129,1.731,1.731,0,0,0-.385,1.134C515.8,1023.469,515.487,1023.694,515.1,1023.694Z",
    transform: "translate(-514.4 -1014.6)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M751.2,1023.694c-.388,0-.7-.223-.7-.5a2.488,2.488,0,0,1,.523-1.564,1.86,1.86,0,0,0,0-2.268,2.6,2.6,0,0,1,0-3.129,1.73,1.73,0,0,0,.386-1.134c0-.277.313-.5.7-.5s.7.223.7.5a2.488,2.488,0,0,1-.523,1.564,1.86,1.86,0,0,0,0,2.268,2.6,2.6,0,0,1,0,3.129,1.731,1.731,0,0,0-.386,1.134C751.9,1023.469,751.587,1023.694,751.2,1023.694Z",
    transform: "translate(-750.5 -1014.6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M987.3,1023.694c-.388,0-.7-.223-.7-.5a2.488,2.488,0,0,1,.523-1.564,1.86,1.86,0,0,0,0-2.268,2.6,2.6,0,0,1,0-3.129,1.73,1.73,0,0,0,.385-1.134c0-.277.313-.5.7-.5s.7.223.7.5a2.488,2.488,0,0,1-.523,1.564,1.861,1.861,0,0,0,0,2.268,2.6,2.6,0,0,1,0,3.129,1.731,1.731,0,0,0-.385,1.134C988,1023.469,987.69,1023.694,987.3,1023.694Z",
    transform: "translate(-986.6 -1014.6)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApSmokeControlSystemIcon);
export default __webpack_public_path__ + "static/media/ap-smoke-control-system-icon.c19e37bbead31afaa3c32697393b430b.svg";
export { ForwardRef as ReactComponent };